import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getpickListData,
  updateChildProfile } from
"../../../services/liferay/baraemServices";
import { config } from "../../../utils/constants";
import Country from "../../../common/Country";
import DatePicker from "react-datepicker";
import AlertDependent from "../../../common/AlertDependent";
import {
  configureFirstIframe,
  getLastNineCharacters,
  getLayoutDirection,
  isArabic } from
"../../../utils/util";

const EditChild = ({ translationMap }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { childData } = location.state || {};
  const [formData, setFormData] = useState({});
  const [dubaiHospitalData, setDubaiHospitalsData] = useState([]);
  const [disabillitiesList, setDisabillitiesList] = useState([]);
  const [, setPregnancyDurationList] = useState([]);
  const [bornInDubai, setBornInDubai] = useState(null);
  const [isDiagnosed, setIsDiagnosed] = useState(null);
  const [base64, setBase64] = useState("");
  const [, setFileName] = useState("");
  const [editBase64, setEditBase64] = useState();
  const [otherHospitalsData, setOtherHospitalsData] = useState([]);
  const [, setCountryLoading] = useState(false);
  const [imgErrorMessage, setImgErrorMessage] = useState("");
  const [imageError, setImageError] = useState(false);

  const [mappedPregnancyDuration, setMappedPregnancyDuration] = useState("");
  const [selectdisabilityError, setSelectDisabilityError] = useState(false);
  const [otherDisabilityError, setOtherDisabilityError] = useState(false);

  const mapPrematurityToDuration = (prematurityWeeks) => {
    const weeks = 40 - prematurityWeeks;
    if (weeks >= 37) {
      return `37 ${translationMap?.weeksOrMore ?? "weeks or more"}`;
    } else if (weeks > 26) {
      return `${weeks} ${translationMap?.weeksText ?? "weeks"}`;
    } else if (weeks <= 26) {
      return `26 ${translationMap?.weeksOrLess ?? "weeks or less"}`;
    } else {
      return `${translationMap?.invalidDuration ?? "Invalid duration"}`;
    }
  };

  const handleChangeNationality = (e) => {
    setFormData((prevData) => ({ ...prevData, nationality: e.target.value }));
  };

  const handleDiagnosisChange = (value) => {
    setIsDiagnosed(value);

    setFormData((prevData) => ({ ...prevData, diagnosedDisability: "" }));
    setFormData((prevData) => ({ ...prevData, disabilities: value }));
    setFormData((prevData) => ({ ...prevData, otherDisability: "" }));
  };

  const handleDisabilities = (e) => {
    setSelectDisabilityError(false);
    setFormData((prevData) => ({
      ...prevData,
      diagnosedDisability: e.target.value
    }));
  };

  useEffect(() => {
    if (childData) {
      setFormData(childData);
      setBornInDubai(childData.hospital);

      setBase64(childData.imageProfileBase64);
      setIsDiagnosed(childData.disabilities);

      const prematurityWeeks = parseInt(childData.prematurity, 10);
      const mappedValue = mapPrematurityToDuration(prematurityWeeks);
      setMappedPregnancyDuration(mappedValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childData]);
  useEffect(() => {
    configureFirstIframe(1000, 2200, true);

    const fetchHospitals = async () => {
      try {
        const dubaiHospitalList = await getpickListData(
          "dubai-health-hospitals"
        );
        const disabillitiesList = await getpickListData(
          "disability-developmental-delay"
        );
        const pregnancyDurationList = await getpickListData(
          "pregnancy-duration"
        );

        const otherHospitalsList = await getpickListData(
          "other-nondubai-hospitals"
        );

        if (dubaiHospitalList.status === 200) {
          const listTypeEntries = dubaiHospitalList.data.data.listTypeEntries;
          setDubaiHospitalsData(listTypeEntries);
        }
        setDisabillitiesList(disabillitiesList.data.data.listTypeEntries);
        setPregnancyDurationList(
          pregnancyDurationList.data.data.listTypeEntries
        );
        setOtherHospitalsData(otherHospitalsList.data.data.listTypeEntries);
      } catch (err) {
        console.error(err);
      }
    };
    fetchHospitals();
  }, []);
  const convertFileToBase64 = async (file) => {
    try {
      const reader = new FileReader();

      const base64 = await new Promise((resolve, reject) => {
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });

      return base64;
    } catch (error) {
      console.error("Error converting file to Base64:", error);
      throw error;
    }
  };
  const handleFileChange = async (event) => {
    setImgErrorMessage("");
    setImageError(false);
    const file = event.target.files[0];
    if (file) {
      try {
        const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
        const maxSizeInMB = 5;
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

        let errorMessage = "";

        if (!allowedTypes.includes(file.type)) {
          errorMessage =
          translationMap?.imageFormateError ??
          "Please upload a valid image file (PNG, JPG, JPEG).";
        } else if (file.size > maxSizeInBytes) {
          errorMessage =
          translationMap?.imageSizeError ??
          "File size must be less than 5MB.";
        }

        if (errorMessage) {
          setImgErrorMessage(errorMessage);
          setImageError(true);
          return;
        }
        const base64String = await convertFileToBase64(file);
        setEditBase64(base64String);
        setFileName(file.name);
        setFormData((prevData) => ({ ...prevData, editBase64: base64String }));


      } catch (error) {
        console.error("Error converting file:", error);
      }
    }
  };

  const validateForm = () => {
    let hasError = false;
    if (
    formData.diagnosedDisability === "other" &&
    !formData.otherDisability.trim())
    {
      hasError = true;
      setOtherDisabilityError(true);
    }

    if (
    formData.disabilities === "yes" &&
    !formData.diagnosedDisability.trim())
    {
      hasError = true;
      setSelectDisabilityError(true);
    }

    return hasError ? false : true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const isFormValid = validateForm();
      if (!isFormValid) {
        return;
      }
      const updateResponse = await updateChildProfile(formData);
      if (updateResponse.status === 200) {
        navigate("/", {
          state: {
            childUpdateStatus: true
          }
        });
      }
    } catch (error) {

    }
  };
  const parseDate = (dob) => {
    if (!dob) return null;

    const formattedDob = new Date(dob);

    return formattedDob;
  };

  if (!childData) {
    return <p>Loading ...</p>;
  }
  return (
    <>
      <div
        className={` custombody_color ${getLayoutDirection()}`}
        id="sectionManageDependent">
        
        <section
          className="w-100 clearfix BaraemMainSection"
          id="CoverPlanActive"
          style={{
            marginTop: "30px"
          }}>
          
          <div className="container customContainer2">
            <div className="Title_Inner_Box">
              <h6 className="MainTitleOne">
                {translationMap?.editChild ?? "Edit Profile"}
              </h6>
            </div>

            <div className="container customContainer customContainer3">
              <div className="cover_inner_wrapper">
                <div className="cover_main_box1">
                  {imageError &&
                  <AlertDependent
                    setError={setImageError}
                    alert_text={imgErrorMessage} />

                  }
                  <div className="baraem_main_inner_wrapper baraem_main_inner_form_wrapper">
                    <form
                      className="form_box radio_form"
                      onSubmit={handleSubmit}>
                      
                      <div className="Inner_Box">
                        <div className="row">
                          <div className="col-12 col-md-12 col-lg-12">
                            <div className="image_select_box">
                              <div className="input_box">
                                <div className="image_main_box">
                                  <div className="imageWrapper">
                                    <img
                                      className="image"
                                      src={
                                      editBase64 ?
                                      `data:image/png;base64,${editBase64}` :
                                      base64 ?
                                      `data:image/png;base64,${base64}` :
                                      `${config.assestsBase}img/baraem_profile_img.png`
                                      }
                                      alt={"Displaying child logo"} />
                                    
                                  </div>
                                </div>
                                <label for="images1" className="file-upload">
                                  <input
                                    type="file"
                                    className="file-input"
                                    id="images1"
                                    onChange={handleFileChange}
                                    accept=".png, .jpg, .jpeg" />
                                  
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    
                                    <path
                                      d="M6.99984 2.91669V11.0834M2.9165 7.00002H11.0832"
                                      stroke="#002F70"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round" />
                                    
                                  </svg>
                                  {editBase64 ?
                                  translationMap?.imageUploadSuccessfully ??
                                  "image uploaded successfully" :
                                  base64 ?
                                  "" :
                                  translationMap?.uploadChildPhoto ??
                                  "Upload your child photo (optional)"}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="Inner_Box">
                        <div className="input_field_box">
                          <div className="input_inner_box">
                            <div className="row">
                              <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box">
                                  <label for="html">
                                    {translationMap?.childName ?? "Child Name"}
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    placeholder={formData.name}
                                    className="input_field disable_field"
                                    disabled />
                                  
                                </div>
                              </div>
                              <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box ">
                                  <div className="input_box custom_date_box">
                                    <label for="html">
                                      {translationMap?.childDOB ??
                                      "Childs date of birth"}
                                    </label>
                                    <div className="input_wrap">
                                      <DatePicker
                                        selected={
                                        formData.dob ?
                                        parseDate(formData.dob) :
                                        null
                                        }
                                        placeholderText={
                                        translationMap?.dobPlaceholder ??
                                        "DD/MM/YYYY"
                                        }
                                        className="date_input input_field disable_field"
                                        id="displayDateInput"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="dd/MM/yyyy"
                                        onFocus={(e) => e.target.blur()}
                                        disabled={true} />
                                      
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="Inner_Box">
                        <div className="input_field_box">
                          <div className="input_inner_box">
                            <div className="row">
                              <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box">
                                  <label for="html">
                                    {translationMap?.contactNumber ??
                                    "Contact Number"}
                                  </label>
                                  <input
                                    type="tel"
                                    name="name"
                                    disabled
                                    placeholder={`+971 ${getLastNineCharacters(
                                      formData.mobileNumber
                                    )}`}
                                    className="input_field disable_field" />
                                  
                                </div>
                              </div>
                              <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box">
                                  <label for="html">
                                    {translationMap?.gender ?? "Gender"}{" "}
                                  </label>
                                  <div className="row">
                                    <div className="col-12 col-md-6 col-lg-6">
                                      <div className="radio_box">
                                        <div className="radio_box">
                                          <input
                                            type="radio"
                                            id="male"
                                            name="gender"
                                            value="M"
                                            checked={formData.gender === "M"}
                                            disabled
                                            className="disable_field" />
                                          
                                          <label htmlFor="male">
                                            {translationMap?.male ?? "Male"}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6">
                                      <div className="radio_box">
                                        <div className="radio_box">
                                          <input
                                            type="radio"
                                            id="female"
                                            name="gender"
                                            value="F"
                                            checked={formData.gender === "F"}
                                            disabled
                                            className="disable_field" />
                                          
                                          <label htmlFor="female">
                                            {translationMap?.female ?? "Female"}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="Inner_Box">
                        <div className="input_field_box">
                          <div className="input_inner_box">
                            <div className="row">
                              <div className="col-12 col-md-12 col-lg-6">
                                <Country
                                  country={formData.nationality}
                                  required={true}
                                  onChangeHandler={handleChangeNationality}
                                  optionDefault={
                                  translationMap?.nationalityPlaceholder ??
                                  "please select nationality"
                                  }
                                  lable={
                                  translationMap?.nationality ??
                                  "please select nationality"
                                  }
                                  setCountryLoading={setCountryLoading}
                                  translationMap={translationMap} />
                                
                              </div>
                              <div className="col-12 col-md-12 col-lg-6">
                                <div className="select_custom_box">
                                  <label for="html">
                                    {translationMap?.whatWasDurationOfPregnancy ??
                                    "What was the duration of the pregnancy?"}
                                  </label>
                                  <div
                                    class="select_custom_box2 select disable_field_custom_box"
                                    disabled="disabled">
                                    
                                    <div
                                      class="selectBtn"
                                      data-type="firstOption"
                                      disabled="disabled">
                                      
                                      {mappedPregnancyDuration}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="Inner_Box">
                        <div className="input_field_box">
                          <div className="input_inner_box">
                            <div className="row">
                              <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box">
                                  <label for="html">
                                    {translationMap?.nursery ??
                                    "Nursery/School Name (optional)"}
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    placeholder={
                                    translationMap?.schoolPlaceholder ??
                                    "Write facility name here"
                                    }
                                    className="input_field"
                                    maxLength={100}
                                    value={formData.nurserySchoolName}
                                    onChange={(e) =>
                                    setFormData((prevData) => ({
                                      ...prevData,
                                      nurserySchoolName:
                                      e.target.value.replace(
                                        /[^A-Za-z\u0600-\u06FF\s]/g,
                                        ""
                                      )
                                    }))
                                    } />
                                  
                                </div>
                              </div>
                              <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box">
                                  <label for="html">
                                    {translationMap?.followUpClinic ??
                                    "Follow-up Clinic/Hospital (optional)"}
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    placeholder={
                                    translationMap?.followupPlaceholder ??
                                    "Write facility name here"
                                    }
                                    className="input_field"
                                    maxLength={100}
                                    value={formData.followUpHospital}
                                    onChange={(e) =>
                                    setFormData((prevData) => ({
                                      ...prevData,
                                      followUpHospital:
                                      e.target.value.replace(
                                        /[^A-Za-z\u0600-\u06FF\s]/g,
                                        ""
                                      )
                                    }))
                                    } />
                                  
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="Inner_Box">
                        <div className="input_field_box">
                          <div className="input_inner_box">
                            <div className="row custom_row">
                              <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box">
                                  <label for="html">
                                    {translationMap?.bornIn ?? "Born in"}{" "}
                                  </label>
                                  <div className="row">
                                    <div className="col-12 col-md-6 col-lg-6">
                                      <div className="radio_box">
                                        <input
                                          type="radio"
                                          id="baraemtest3"
                                          name="toggle"
                                          value="dubai"
                                          checked={
                                          formData.hospital === "dubai"
                                          }
                                          disabled
                                          className="disable_field"
                                          // onChange={() => handleBornInChange("dubai")}
                                          required />
                                        
                                        <label htmlFor="baraemtest3">
                                          {translationMap?.dubaiHealthHospital ??
                                          "Dubai Health Hospital"}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6">
                                      <div className="radio_box">
                                        <input
                                          type="radio"
                                          id="baraemtest4"
                                          name="toggle"
                                          value="other"
                                          checked={
                                          formData.hospital === "other"
                                          }
                                          disabled
                                          className="disable_field" />
                                        
                                        <label for="baraemtest4">
                                          {translationMap?.otherHospital ??
                                          "Other Hospital"}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {bornInDubai === "dubai" &&
                              <div className="col-12 col-md-12 col-lg-6">
                                  <div className="select_custom_box">
                                    <label htmlFor="html">
                                      {translationMap?.selectHospital ??
                                    "Select Hospital"}
                                    </label>
                                    <div className="dropdown-form">
                                      <select
                                      id="dropdown"
                                      value={formData.bornIn}
                                      disabled={true}>
                                      
                                        <option value="" disabled>
                                          {translationMap?.selecthospitalDropDown ??
                                        "Please select the hospital"}
                                        </option>
                                        {dubaiHospitalData.map((entry) =>
                                      <option
                                        key={entry.id}
                                        value={entry.key}>
                                        
                                            {isArabic() ?
                                        entry.name_i18n["ar-SA"] :
                                        entry.name_i18n["en-US"]}
                                          </option>
                                      )}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              }
                              {bornInDubai === "other" &&
                              <div className="col-12 col-md-12 col-lg-6">
                                  <div className="select_custom_box">
                                    <label htmlFor="html">
                                      {translationMap?.otherHospitalLabel ??
                                    "Please specify which hospital"}
                                    </label>
                                    <div className="dropdown-form">
                                      <select
                                      id="dropdown"
                                      value={formData.bornIn}
                                      disabled={true}>
                                      
                                        <option value="" disabled>
                                          {translationMap?.selecthospitalDropDown ??
                                        "Please select the hospital"}
                                        </option>
                                        {otherHospitalsData.map((entry) =>
                                      <option
                                        key={entry.id}
                                        value={entry.key}>
                                        
                                            {isArabic() ?
                                        entry.name_i18n["ar-SA"] :
                                        entry.name_i18n["en-US"]}
                                          </option>
                                      )}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="Inner_Box">
                        <div className="input_field_box">
                          <div className="input_inner_box">
                            <div className="row custom_row">
                              <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box">
                                  <label for="html">
                                    {translationMap?.childAlreadyDiagnosed ??
                                    "Is your child already diagnosed with a disability/developmental delay?"}{" "}
                                  </label>
                                  <div className="row">
                                    <div className="col-12 col-md-6 col-lg-6">
                                      <div className="radio_box">
                                        <input
                                          type="radio"
                                          id="baraemtest5"
                                          name="radio-group-3"
                                          value="no"
                                          checked={
                                          formData.disabilities === "no"
                                          }
                                          onChange={() =>
                                          handleDiagnosisChange("no")
                                          } />
                                        

                                        <label for="baraemtest5">
                                          {translationMap?.no ?? "No"}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6">
                                      <div className="radio_box">
                                        <input
                                          type="radio"
                                          id="baraemtest6"
                                          name="radio-group-3"
                                          value="yes"
                                          checked={
                                          formData.disabilities === "yes"
                                          }
                                          onChange={() =>
                                          handleDiagnosisChange("yes")
                                          } />
                                        

                                        <label for="baraemtest6">
                                          {translationMap?.yes ?? "Yes"}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {isDiagnosed === "yes" &&
                              <div className="col-12 col-md-12 col-lg-6">
                                  <div className="select_custom_box">
                                    <label htmlFor="disabilitySelect">
                                      {translationMap?.selectDisability ??
                                    "Select disability/developmental delay"}
                                    </label>
                                    <div className="dropdown-form">
                                      <select
                                      id="dropdown"
                                      value={formData.diagnosedDisability}
                                      onChange={handleDisabilities}>
                                      
                                        <option value="" disabled>
                                          {translationMap?.selectDisabilityPlaceholder ??
                                        "Please select disability"}
                                        </option>
                                        {disabillitiesList.map((entry) =>
                                      <option
                                        key={entry.id}
                                        value={entry.key}>
                                        
                                            {isArabic() ?
                                        entry.name_i18n["ar-SA"] :
                                        entry.name_i18n["en-US"]}
                                          </option>
                                      )}
                                      </select>
                                    </div>
                                  </div>
                                  {selectdisabilityError &&
                                <span
                                  style={{
                                    color: "red",
                                    display: "block"
                                  }}>
                                  
                                      {translationMap?.errorMessageText ??
                                  "This field is required"}
                                    </span>
                                }
                                </div>
                              }
                            </div>

                            {isDiagnosed === "yes" &&
                            formData.diagnosedDisability === "other" &&
                            <div className="row custom_row">
                                  <div className="col-12 col-md-12 col-lg-12">
                                    <div className="custom_input_box">
                                      <label htmlFor="otherDisease">
                                        {translationMap?.pleaseSpecifyDisease ??
                                    "Please specify the disease"}
                                      </label>
                                      <input
                                    type="text"
                                    id="otherDisease"
                                    placeholder={
                                    translationMap?.writeDetailsText ??
                                    "Write more details here"
                                    }
                                    className="input_field"
                                    value={formData.otherDisability}
                                    maxLength={100}
                                    onChange={(e) => {
                                      setOtherDisabilityError(false);
                                      setFormData((prevData) => ({
                                        ...prevData,
                                        otherDisability:
                                        e.target.value.replace(
                                          /[^A-Za-z\u0600-\u06FF\s]/g,
                                          ""
                                        )
                                      }));
                                    }} />
                                  
                                    </div>
                                    {otherDisabilityError &&
                                <span
                                  style={{
                                    color: "red",
                                    display: "block"
                                  }}>
                                  
                                        {translationMap?.errorMessageText ??
                                  "This field is required"}
                                      </span>
                                }
                                  </div>
                                </div>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="Inner_Box">
                        <div className="form_buton_box">
                          <span>
                            <button type="submit" className="blue_btn_link">
                              {translationMap?.saveChild ?? "Save"}
                            </button>
                          </span>
                          <span>
                            <button
                              type="button"
                              onClick={() => navigate("/")}
                              className="bluetrans_btn_link">
                              
                              {translationMap?.back ?? "Back"}
                            </button>
                          </span>
                          <span>
                            <button
                              onClick={() => navigate("/")}
                              className="Orangetrans_btn_link">
                              
                              {translationMap?.cancel ?? "Cancel"}
                            </button>
                          </span>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="cover_main_box2"></div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>);

};

export default EditChild;